import React, { useContext, useState } from 'react';

import './CallMeBackForm.css';

import { FormFieldLabel, Text } from '../../../StyledComponents';
import VettingInput from '../VettingInput/VettingInput';
import VettingDropDown from '../../Common/VettingDropDown/VettingDropDown';
import {
  checkInputValidity,
  createArray,
  getTrackingIds,
  registerEnterEvent
} from '../../../Utility/utility';
import { SalesContext } from '../../../Context/SalesContext';
import { submitCallmeBack } from '../../../Services/Services';
import { GreenCircleIcon, RedCircleIcon } from '../Svg';

import {
  tagOnCallMeBackFormInteraction,
  tagOnCallMeBackSuccess,
  tagOnCallMeBackFail
} from "./../../../Tagging/SalesTagging";

const CallMeBackForm = () => {

  const context = useContext(SalesContext);
  const [callMeBackStatus, setCallMeBackStatus] = useState('pending');
  const [isFormValid, setIsFormValid] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const miniAppProactiveSales = !!(window.isFtthMA);
  const [formData, setFormData] = useState({
    // Form Fields
    formComponents: {
      firstName: {
        name: "Name",
        type: "input",
        value: "",
        width: 100,
        validations: {
          required: true,
          invalidMessage: "Please enter a valid name",
          minLength: 2,
          maxLength: 50
        },
        config: {
          type: "text",
          required: true,
          placeholder: "Eg. John",
          tabIndex: "1",
          minLength: 2,
          maxLength: 50
        },
        isValid: false,
        isTouched: false
      },
      lastName: {
        name: "Last name",
        type: "input",
        value: "",
        width: 100,
        validations: {
          required: true,
          invalidMessage: "Please enter a valid last name",
          minLength: 2,
          maxLength: 50
        },
        config: {
          type: "text",
          required: true,
          placeholder: "Eg. Smith",
          tabIndex: "2",
          minLength: 2,
          maxLength: 50
        },
        isValid: false,
        isTouched: false
      },
      email: {
        name: "Email address",
        type: "input",
        value: "",
        width: 100,
        validations: {
          type: 'email',
          required: true,
          invalidMessage: "Please enter a valid email address",
        },
        config: {
          type: "text",
          required: true,
          placeholder: "Eg. john@gmail.com",
          tabIndex: "3"
        },
        isValid: false,
        isTouched: false
      },
      cellPhoneNo: {
        name: "Cellphone number",
        type: "input",
        value: "",
        width: 100,
        validations: {
          type: 'cellphoneNo',
          required: true,
          invalidMessage: "Please enter a valid cell phone number",
        },
        config: {
          type: "text",
          required: true,
          placeholder: "Eg. 082 1234 567",
          tabIndex: "4"
        },
        isValid: false,
        isTouched: false
      },
      preferredTime: {
        name: "At what time can we contact you? (Optional)",
        type: "dropDown",
        value: "",
        options: ["Anytime",
        "08:00  - 10:00",
        "10:00  - 12:00",
        "12:00  - 14:00",
        "14:00  - 16:00",
        "16:00  - 18:00",
        "18:00  - 20:00"],
        width: 100,
        validations: {
          required: false,
          invalidMessage: "Please select a valid slot",
        },
        config: {
          type: "select",
          required: false,
          placeholder: "Please select a time slot",
          tabIndex: "4"
        },
        isValid: true,
        isTouched: false
      }
    },
    isFormValid: false
  });

  const formCompArray = createArray(formData.formComponents);

  registerEnterEvent();

  const formComponentChangeHandler = (event, inputIdentifier) => {
    if (inputIdentifier === 'firstName' && event.length === 1) {
      tagOnCallMeBackFormInteraction("new customer vetting");
    }
    const formCompsCopy = { ...formData.formComponents };
    const changedComponent = { ...formCompsCopy[inputIdentifier] };
    
    if (inputIdentifier == 'email' || inputIdentifier == 'cellPhoneNo') {
      changedComponent.value = event.trim();
    }
    else {
      changedComponent.value = event;
    }

    changedComponent.isValid = checkInputValidity(
      changedComponent.value,
      changedComponent.validations
    );

    changedComponent.isTouched = true;

    const newFormComps = {
      ...formCompsCopy,
      [inputIdentifier]: changedComponent
    }

    const isFormValid = !Object.keys(newFormComps).find(e => newFormComps[e].isValid === false) ? true : false;

    setFormData({
      formComponents: newFormComps,
      isFormValid: isFormValid
    });

    setIsFormValid(isFormValid);
  };

  const submitForm = () => {

    const agentUsername = sessionStorage.getItem('retailUserDetails') ? JSON.parse(sessionStorage.getItem('retailUserDetails')).username : null;

    context.setShowSpinner(true);

    let payload = {
      leadType: "callMeBack",
      contactEmailAddress: formData.formComponents.email.value,
      contactFirstName: formData.formComponents.firstName.value,
      contactLastName: formData.formComponents.lastName.value,
      contactMobilePhoneNumber: formData.formComponents.cellPhoneNo.value,
      preferredContactTime: formData.formComponents.preferredTime.value,
      mrktIndicator: getTrackingIds(),
      channel: context?.selectedPackage?.status || "Live",
      callMeBack: true
    }

    if (agentUsername) {

      payload.agent = {
        username: agentUsername,
      }
    }
    
    submitCallmeBack(payload, context)
      .then(res => {
        context.setShowSpinner(false);
        context.setUserDetails({
          key: "referenceNo",
          value: res.result && res.result.referenceNumber,
        });
        setCallMeBackStatus('success');
        tagOnCallMeBackSuccess(formData.formComponents.cellPhoneNo.value, res?.result?.referenceNumber)
      })
      .catch(_err => {
        context.setShowSpinner(false);
        setCallMeBackStatus('fail');
        tagOnCallMeBackFail("new customer vetting");
      });
  }


  return (
    <div>
      {
        callMeBackStatus === 'pending' ?
          <div className={isFocused && miniAppProactiveSales ? 'call-me-back-wrapper-miniapp-focused' : 'call-me-back-wrapper'}>
            <Text fontSize="20px"><strong>Don’t have the all the documents?</strong></Text>
            <Text fontSize="16px">Give us your information and a call centre agent will be in touch.</Text>
            <br />
            <div className="call-me-back-inputs">
              {
                formCompArray.map((item) => {
                  return (
                    <div className={`input-field-wrapper-${item?.config?.width}`} key={item.key}>
                      <FormFieldLabel
                        hide={item?.config?.hideLabel}
                        automationidattr={`callMeBack${item.key}`}
                      >
                        {item.config.name}
                      </FormFieldLabel>

                      { item.config.type === "input" ?
                          <VettingInput
                            {...item.config}
                            updateValue={formComponentChangeHandler}
                            inputIdentifier={item.key}
                            automationidattr={`callMeBack`}
                            onFocus={(_event) => setIsFocused(true)}
                            onBlur={(_event) => setIsFocused(false)}
                          />
                          :
                          null
                      }

                      { item.config.type === "dropDown" ?
                          <VettingDropDown
                            selectedValue={item.config.value}
                            placeholder={item.config.config.placeholder}
                            options={item.config.options}
                            updateSelectedOption={formComponentChangeHandler}
                            inputIdentifier={item.key}
                            automationidattr={item.key}
                          />
                          :
                          null
                      }
                    </div>
                  )
                })
              }
            </div>

            <button disabled={!isFormValid} onClick={() => submitForm()} className="call-me-back-button">Submit</button>
          </div>
          :
          null
      }

      {
        callMeBackStatus === 'success' ?
          <div className="call-me-back-section">
            <GreenCircleIcon />
            <Text fontSize="20px"><strong>Let's get connected!</strong></Text>
            <br />
            <Text fontSize="16px">Thanks for your interest in getting connected with our fibre plans. We can't wait to get you set up with lightning-fast internet.</Text>
            <Text fontSize="16px">A friendly sales agent will be in touch shortly to discuss your chosen plan and finalise your order.</Text>
            <br />

            { context?.userDetails?.referenceNo &&

              <>
                <hr className="call-me-back-hrline" />
                <br />
                <div className="call-me-back-desc"><Text fontSize="16px"><strong>Reference number: </strong>{context?.userDetails?.referenceNo}</Text></div>
              </>
            }
          </div>
          :
          null
      }

      {
        callMeBackStatus === 'fail' ?
          <div className="call-me-back-section">
            <RedCircleIcon />
            <Text fontSize="20px"><strong>Oops...</strong></Text>
            <br />
            <div className="call-me-back-desc"><Text fontSize="16px">We were unable to submit your request. Please try again later.</Text></div>
          </div>
          :
          null
      }
    </div>
  )
}

export default CallMeBackForm;